import { useQuery } from "@tanstack/react-query";
import { approverService } from "../../api/overtimeService";

export const MY_APPROVERS_KEY = ["me:approvers"];

export const useMyApprovers = () =>
  useQuery({
    queryKey: MY_APPROVERS_KEY,
    queryFn: approverService.getMine,
    staleTime: 10 * 60 * 1000,
  });

// Route for one request type ("DTR" | "OVERTIME" | "LEAVE" | "VALIDATION"), or null.
export const getRouteFor = (data, requestType) =>
  data?.byType?.find((route) => route.requestType === requestType) ?? null;

// "Level 1: Ana Cruz or Ben Reyes → Level 2: Carla Diaz", or the default.
export const describeRoute = (route) => {
  if (!route || route.source === "DEFAULT" || !route.levels?.length)
    return "Your branch manager / HR";
  return route.levels
    .map(
      (level) =>
        `Level ${level.level}: ${level.approvers.map((a) => a.name).join(" or ")}`,
    )
    .join(" → ");
};
